<template>
    <div id="alarminfoContent">
        <div class="data_head">
            <el-button type="primary" @click="openAlarmDialog()" class="searchButton">
                添&nbsp;加
            </el-button>
        </div>
        <div class="table tableContent">
            <el-table :data="dataList" style="width: 100%;" stripe
                      :header-cell-style="{background:'#335ABB',color:'#FFF'}">
                <el-table-column align="center" prop="measureNoSet" label="测点"></el-table-column>
                <el-table-column align="center" prop="phoneNumberSet" label="手机号"></el-table-column>
                <el-table-column align="center" prop="intervalSeconds" label="发送间隔"></el-table-column>
                <el-table-column align="center" label="操作" fixed="right" width="300">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)" type="warning">修改</el-button>
                        <el-button size="mini" @click="handleDelete(scope.row)" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        
        <el-dialog :title="alarmTypeTitle + '短信发送配置'" center :visible.sync="alarmDialog" width="40%"
                   :modal-append-to-body="false">
            <el-form label-width="100px" :model="smsAlarmForm" ref="ruleForm" :rules="rules">
                <el-form-item label="选择测点" prop="measureNoSetArr">
                    <el-cascader
                        placeholder="请选择测点"
                        ref="spot"
                        v-model="smsAlarmForm.measureNoSetArr"
                        :options="paramOptions"
                        :props="{
              value: 'code',
              label: 'name',
              children: 'childHashSet',
              emitPath: false,
              multiple: true,
            }"
                        :show-all-levels="false"
                        clearable
                        collapse-tags
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="通知手机号" prop="phoneNumberSetArr">
                    <el-input v-model="data.value" v-for="data in smsAlarmForm.phoneNumberSetArr" :key="data.id"
                              placeholder="请输入通知手机号">
                        <template slot="append">
                            <div style="display: flex;align-items: center;justify-content: center">
                                <i class="el-icon-circle-plus-outline" style="cursor:pointer;"
                                   @click="addSmsAlarmPhone"></i>
                                <i class="el-icon-remove-outline" style="cursor:pointer;margin-left: 10px"
                                   @click="removeSmsAlarmPhone(index)"></i>
                            </div>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="发送间隔" prop="intervalSeconds">
                    <el-input v-model="smsAlarmForm.intervalSeconds" placeholder="请输入发送间隔">
                        <template slot="append">
                            秒
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item align="right">
                    <el-button type="primary" @click="addAlarm('ruleForm')">确定</el-button>
                    <el-button type="info" @click="alarmDialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--修改-->
        <el-dialog title="修改信息" center :visible.sync="updataDialog" width="40%" :modal-append-to-body="false">
            <el-form label-width="80px" :model="updataForm" ref="updataForm" :rules="rules">
                <el-form-item label="设备名称" prop="alarmName">
                    <el-input v-model="updataForm.alarmName"></el-input>
                </el-form-item>
                <el-form-item label="声量指令" prop="alarmVolume">
                    <el-input v-model="updataForm.alarmVolume"></el-input>
                </el-form-item>
                <el-form-item label="开启指令" prop="alarmStart">
                    <el-input v-model="updataForm.alarmStart"></el-input>
                </el-form-item>
                <el-form-item label="关闭指令" prop="alarmEnd">
                    <el-input v-model="updataForm.alarmEnd"></el-input>
                </el-form-item>
                <el-form-item align="right">
                    <el-button type="primary" @click="updataAlarm('updataForm')">确定</el-button>
                    <el-button type="info" @click="updataDialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--绑定测点-->
        <el-dialog title="绑定测点" center :visible.sync="bindDialog" width="40%" :modal-append-to-body="false"
                   :close-on-click-modal="false">
            <el-form label-width="80px" :model="setBindForm" ref="bindForm" :rules="rulesBind">
                <el-form-item label="测点选择" prop="measures">
                    <el-cascader
                        v-model="setBindForm.measures"
                        :options="paramOptions"
                        :props="{value:'code',label:'name',children:'childHashSet',emitPath:false,multiple:true}"
                        :show-all-levels="false"
                        collapse-tags
                    ></el-cascader>
                </el-form-item>
                <el-form-item align="center">
                    <el-button type="primary" @click="bindPoint('bindForm')">绑定</el-button>
                    <el-button type="info" @click="bindDialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    
    
    </div>
</template>

<script>
export default {
    name: "AlarmInfor",
    data() {
        return {
            dataList: [],
            alarmDialog: false,
            alarmTypeTitle: "",
            smsAlarmForm: {
                measureNoSetArr: "",
                measureNoSet: "",
                phoneNumberSetArr: [
                    {
                        value: "",
                        id: 1
                    }
                ],
                phoneNumberSet: "",
                intervalSeconds: ""
            },
            rules: {
                measureNoSetArr: [{ required: true, message: "请选择测点", trigger: "change" }],
                phoneNumberSetArr: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                    {
                        validator: (rule, value, callback) => {
                            let isNull = false
                            for (let i = 0; i < value.length; i++) {
                                if (value[i].value == "") {
                                    isNull = true
                                    break
                                }
                            }
                            if (isNull) {
                                callback(new Error("手机号不能为空"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur"
                    },
                    {
                        validator: (rule, value, callback) => {
                            let isNull = false
                            for (let i = 0; i < value.length; i++) {
                                if (value[i].value.length != 11) {
                                    isNull = true
                                    break
                                }
                            }
                            if (isNull) {
                                callback(new Error("手机号格式不正确"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur"
                    }
                ],
                intervalSeconds: [{ required: true, message: "请输入发送间隔", trigger: "blur" }]
            },
            updataDialog: false,
            updataForm: {
                id: "",
                alarmName: "",
                alarmVolume: "",
                alarmStart: "",
                alarmEnd: ""
            },
            bindDialog: false, //绑定测点
            paramOptions: [],
            rulesBind: {
                measures: [{ required: true, message: "请选择测点", trigger: "change" }]
            },
            setBindForm: {
                measures: [],
                id: ""
            }
        }
    },
    mounted() {
        this.projectMenus()
        this.getdataList()
    },
    methods: {
        openAlarmDialog() {
            delete this.smsAlarmForm.id
            this.smsAlarmForm.measureNoSetArr = ""
            this.smsAlarmForm.phoneNumberSetArr = [
                {
                    value: "",
                    id: 1
                }
            ]
            this.smsAlarmForm.intervalSeconds = ""
            this.alarmTypeTitle = "添加"
            this.alarmDialog = true
        },
        removeSmsAlarmPhone(index) {
            this.smsAlarmForm.phoneNumberSetArr.splice(index, 1)
        },
        addSmsAlarmPhone() {
            this.smsAlarmForm.phoneNumberSetArr.push({
                value: "",
                id: this.smsAlarmForm.phoneNumberSetArr.length + 1
            })
        },
        //获取测点集合
        projectMenus() {
            this.$axios
                .get("/api/monitor/dataHistory/getMeasureByCode")
                .then((res) => {
                    this.paramOptions = res.data.datas.values;
                });
        },
        /*添加确定按钮*/
        addAlarm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let url = ""
                    if (this.alarmTypeTitle == "添加") {
                        url = "/api/monitor/project/sms/add"
                    } else if (this.alarmTypeTitle == "编辑") {
                        url = "/api/monitor/project/sms/update"
                    }
                    let valueArr = []
                    this.smsAlarmForm.phoneNumberSetArr.forEach(data => {
                        valueArr.push(data.value)
                    })
                    this.smsAlarmForm.phoneNumberSet = valueArr.join(",")
                    this.smsAlarmForm.measureNoSet = this.smsAlarmForm.measureNoSetArr.join(",")
                    this.$axios.post(url, this.smsAlarmForm).then(res => {
                        if (res.data.status == 200) {
                            this.$message({ message: "添加成功", type: "success" })
                            this.alarmDialog = false
                            this.getdataList()
                            this.$refs[formName].resetFields();
                        } else {
                            if (res.data.datas.values) {
                                this.$message({ message: res.data.datas.values, type: "error" })
                            } else {
                                this.$message({ message: res.data.message, type: "error" })
                            }
                        }
                    })
                } else {
                    this.$message({ message: "有必填项未填哦，再检查下吧！", type: "error" })
                }
            })
        },
        /*获取数据列表*/
        getdataList() {
            this.$axios.post("/api/monitor/project/sms/list").then(res => {
                if (res.data.status == 200) {
                    this.dataList = res.data.datas.values;
                }
            })
        },
        //编辑
        handleEdit(info) {
            let obj = JSON.parse(JSON.stringify(info))
            
            this.alarmTypeTitle = "编辑"
            this.smsAlarmForm.id = obj.id
            this.smsAlarmForm.measureNoSetArr = obj.measureNoSet.split(",")
            let phoneArr = obj.phoneNumberSet.split(",")
            let phoneArr2 = []
            phoneArr.forEach((item, index) => {
                phoneArr2.push({
                    value: item,
                    id: index + 1
                })
            })
            this.smsAlarmForm.phoneNumberSetArr = phoneArr2
            this.smsAlarmForm.intervalSeconds = obj.intervalSeconds
            this.alarmDialog = true
        },
        updataAlarm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.put("/api/monitor/project/updateAlarmApparatusById", this.updataForm).then(res => {
                        if (res.data.status == 200) {
                            this.$message({ message: "修改成功", type: "success" })
                            this.updataDialog = false
                            this.getdataList()
                            this.$refs[formName].resetFields();
                        } else {
                            this.$message({ message: res.data.message, type: "error" })
                        }
                    })
                } else {
                    this.$message({ message: "有必填项未填哦，再检查下吧！", type: "error" })
                }
            })
        },
        handleDelete(info) {
            this.$confirm("是否删除当前短信发送配置", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$axios.post("/api/monitor/project/sms/del", {
                    id: info.id
                }).then(res => {
                    if (res.data.status == 200) {
                        this.$message({ message: "删除成功", type: "success" })
                        this.getdataList()
                    } else {
                        if (res.data.datas.values) {
                            this.$message({ message: res.data.datas.values, type: "error" })
                        } else {
                            this.$message({ message: res.data.message, type: "error" })
                        }
                    }
                })
            })
            
        },
        //    绑定测点
        binDing(info) {
            this.setBindForm.id = info.id
            this.$axios.get("/api/monitor/dataHistory/getMeasureByCode", this.setBindForm).then(res => {
                if (res.data.status == 200) {
                    this.paramOptions = res.data.datas.values;
                    this.getPoint(info.id)
                    this.bindDialog = true
                } else {
                    this.$message.error(res.data.message)
                }
            });
        },
        //    获取已有测点project/getBindingAlarmMeasures
        getPoint(id) {
            this.$axios.get("/api/monitor/project/getBindingAlarmMeasures?alarmId=" + id).then(res => {
                // measureNo
                res.data.datas.values.forEach(item => {
                    this.setBindForm.measures.push(item.measureNo)
                })
            })
        },
        // 保存
        bindPoint(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/api/monitor/project/bindingAlarmMeasures", this.setBindForm).then(res => {
                        if (res.data.status == 200) {
                            this.bindDialog = false
                            this.$message.success("绑定成功")
                        } else {
                            this.bindDialog = true
                            this.$message.warning(res.data.message)
                        }
                    })
                } else {
                    this.$message({ message: "有必填项未填哦，再检查下吧！", type: "warning" })
                }
            })
        }
    }
}
</script>

<style>
.el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%) !important;
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
}

.el-dialog__body {
    padding: 10px 20px;
}

.el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
}

/*#alarminfoContent .el-cascader .el-input  .el-input__inner{*/
/*  color: #FFF;*/
/*  background-color: #3457DE;*/
/*}*/

#alarminfoContent .el-date-editor .el-input__inner {
    background-color: #3457DE;
    color: #FFF;
}

#alarminfoContent .el-table {
    color: #A7CCF6;
}

#alarminfoContent .el-table__row {
    background-color: #0B3A68 !important;
}

#alarminfoContent .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #021535;
}

#alarminfoContent .el-table td {
    border: unset;
}

#alarminfoContent .el-table th.is-leaf {
    border-bottom: none;
}

#alarminfoContent .el-form-item {
    margin: 20px 0;
}

</style>

<style scoped>
@import url('../../assets/css/style.css');

/deep/ .el-cascader {
    width: 100%;
}

/deep/ .el-button {
    outline: none;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/project/smsAlarm.vue